import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import defaultStyles from './AppModal.module.scss';

const AppModal = (props) => (
    <ReactModal isOpen={ props.isOpen } className={ props.styles.modal } overlayClassName={ props.styles.overlay }>
        <div className={ props.styles.content }>
            { props.heading
                ? (
                    <div className={ props.styles.heading }>
                        { props.heading }
                    </div>
                ) : null }
            { props.message
                ? (
                    <div className={ props.styles.message }>
                        { props.message }
                    </div>
                ) : null }
            { props.submit
                ? (
                    <button type="submit" className={ props.styles.button } onClick={ props.onButtonClick }>
                        { props.submit }
                    </button>
                )
                : null }
        </div>
    </ReactModal>
);

AppModal.propTypes = {
    styles: PropTypes.shape({
        modal: PropTypes.string,
        overlay: PropTypes.string,
        heading: PropTypes.string,
        message: PropTypes.string,
        button: PropTypes.string,
        content: PropTypes.string
    }),
    heading: PropTypes.string,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element]),
    submit: PropTypes.string,
    onButtonClick: PropTypes.func,
    isOpen: PropTypes.bool
};

AppModal.setAppElement = ReactModal.setAppElement;

AppModal.defaultProps = {
    styles: defaultStyles,
    heading: '',
    message: '',
    submit: '',
    onButtonClick: fp.noop,
    isOpen: true
};

export default AppModal;
